import { Component, OnInit } from '@angular/core'
import { ViewForSelectorComponent } from '../../common/view-for-selector/view-for-selector.component'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { Subscription } from 'rxjs'
import { GovernmentBusinessAPIModel, StatusCountAPIModel } from 'src/app/models/api.model'
import {
  CASE_CLOSED,
  DRAFT_AWAITING_SIGNATURE,
  DRAFT_UNDER_REVIEW,
  IN_PROGRESS,
  SUBMITTED,
  TASK_INITIATED,
  WAITING_ON_CLIENT,
  WAITING_ON_DRAFT
} from 'src/app/constants/stats-cards'
import {
  COMPANY_ENTITY_DISPLAY_ID,
  OFFICE_NAME,
  RECEIVED_ON,
  STATUS,
  TASK_ID,
  TASK_NAME
} from 'src/app/constants/ui.columns'
import { GovernmentBusinessService } from 'src/app/services/government/government-business.service'
import { Router } from '@angular/router'

@Component({
  selector: 'government-business-dashboard',
  templateUrl: './government-business-dashboard.component.html',
  styleUrls: ['./government-business-dashboard.component.scss']
})
export class GovernmentBusinessDashboardComponent implements OnInit {
  pendingItemsList: GovernmentBusinessAPIModel[] = []
  statusCountMap: StatusCountAPIModel[] = []
  pendingItemsTableColumns = [COMPANY_ENTITY_DISPLAY_ID, TASK_ID, TASK_NAME, OFFICE_NAME, RECEIVED_ON, STATUS]
  statsCards = [
    TASK_INITIATED,
    IN_PROGRESS,
    WAITING_ON_CLIENT,
    DRAFT_AWAITING_SIGNATURE,
    WAITING_ON_DRAFT,
    SUBMITTED,
    DRAFT_UNDER_REVIEW,
    CASE_CLOSED
  ]
  governmentBusinessDashboardDetails$: Subscription
  readonly BUSINESS_SUMMARY = `/${GlobalConstants.ROUTING.GOVERNMENT_BUSINESS}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly routingLink = `/${GlobalConstants.ROUTING.GOVERNMENT_BUSINESS}/{0}/${GlobalConstants.ROUTING.DETAILS}`

  constructor(private governmentBusinessService: GovernmentBusinessService, private route: Router) {}

  ngOnInit() {
    this.governmentBusinessService.dispatchFetchDashboardData(
      ViewForSelectorComponent.defaultValue,
      GlobalConstants.SORT_COLUMN.CREATED_DATETIME,
      null
    )

    this.governmentBusinessDashboardDetails$ = this.governmentBusinessService
      .getDashboardDataSelector()
      .subscribe(governmentDashboardInfo => {
        this.pendingItemsList = governmentDashboardInfo?.governmentBusinessPendingItemsList?.content
        this.statusCountMap = governmentDashboardInfo?.statusCountMap
      })
  }

  handleViewForData($event: any) {
    this.governmentBusinessService.dispatchFetchDashboardData(
      $event,
      GlobalConstants.SORT_COLUMN.CREATED_DATETIME,
      null
    )
  }

  ngOnDestroy() {
    this.governmentBusinessDashboardDetails$.unsubscribe()
  }

  viewSummary() {
    this.route.navigate([this.BUSINESS_SUMMARY])
  }
}
